import React from 'react';
import { palette } from '../styles/Palette';

const ClockClockwise = ({ width = "40", height = "37", color = palette.gray500, ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 40 37" 
      fill="none"
      {...props}
    >
    <path 
      fill-rule="evenodd" 
      clip-rule="evenodd" 
      d="M8.06555 10.3682C9.95601 7.10485 12.9541 4.62764 16.5155 3.38646C20.0768 2.14528 23.9651 2.22244 27.4744 3.60394C30.9837 4.98544 33.8811 7.57965 35.6406 10.9155C37.4001 14.2513 37.9049 18.1075 37.0634 21.7839C36.2219 25.4602 34.0899 28.7128 31.0545 30.9511C28.0191 33.1894 24.2816 34.2649 20.5208 33.9823C16.76 33.6996 13.2252 32.0777 10.5585 29.4109C10.1289 28.9813 9.43239 28.9813 9.00282 29.4109C8.57324 29.8405 8.57324 30.5369 9.00282 30.9665C12.0419 34.0056 16.0701 35.854 20.3559 36.1761C24.6418 36.4982 28.901 35.2725 32.3601 32.7218C35.8193 30.171 38.249 26.4643 39.208 22.2747C40.167 18.0852 39.5917 13.6906 37.5865 9.88911C35.5814 6.08759 32.2795 3.13122 28.2803 1.55686C24.2811 -0.0175026 19.8499 -0.10544 15.7914 1.30901C11.7329 2.72346 8.31627 5.5465 6.1619 9.26548C4.50204 12.1308 3.6763 15.3815 3.74689 18.6549L2.21766 17.1257C1.78808 16.6961 1.0916 16.6961 0.662026 17.1257C0.23245 17.5552 0.23245 18.2517 0.662026 18.6813L4.2267 22.246C4.63572 22.655 5.28671 22.6746 5.71888 22.3047C5.85346 22.2197 5.96678 22.1069 6.0524 21.9759L9.34701 18.6813C9.77659 18.2517 9.77659 17.5552 9.34701 17.1257C8.91744 16.6961 8.22096 16.6961 7.79138 17.1257L5.9579 18.9591C5.82653 15.9684 6.5496 12.9851 8.06555 10.3682ZM21.8908 11.7525C21.8908 11.145 21.3983 10.6525 20.7908 10.6525C20.1833 10.6525 19.6908 11.145 19.6908 11.7525V19.4652V20.0599L20.1884 20.3856L26.223 24.3352C26.7314 24.6679 27.4131 24.5256 27.7458 24.0172C28.0785 23.5089 27.9362 22.8272 27.4278 22.4945L21.8908 18.8705V11.7525Z" 
      fill={color}
    />
    </svg>
  );
};

export default ClockClockwise; 